import {
	R3VisualComponentBase
} from "~/classes/base/R3VisualComponenteBase.classes";


export default class R3ButtonClass extends R3VisualComponentBase {
	constructor(text: string = "") {
		super();
		this._text.value = text;
	}
	private _text = ref("");
	get text() {
		return this._text.value;
	}

	set text(value: string) {
		if (value) {
			this._text.value = value;
		}
	}
}